import { Post } from "../http/httpVerbs";

export async function recordVideoPlayback({
    idPost,
    idAprenda,
    idVideo,
    urlvideo,
    videoTotalTime,
    idcreator,
    watchTime,
}) {
    if ((idPost || idAprenda) && idVideo && urlvideo && videoTotalTime && idcreator && watchTime) {
        const data = { idPost, idAprenda, idVideo, urlvideo, videoTotalTime, idcreator, watchTime };
        const endpoint = `${process.env.REACT_APP_API_URL}/video-playback`;
        const response = await Post(endpoint, data);
        return response;
    }

    return null;
}
